<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-12">

        <div class="card shadow-lg border-0 rounded-3">
          <div class="card-body p-4">

            <h4 class="mb-3 text-center">📄 Subir paquete PDF</h4>

            <!-- Input PDF -->
            <div class="mb-3">
              <label for="pdf" class="form-label">Selecciona un archivo PDF</label>
              <input type="file" class="form-control" id="pdf" accept="application/pdf" @change="onFileChange2">
            </div>

            <!-- Botón -->
            <div class="d-grid">
              <button class="btn btn-primary text-light" :disabled="loading || !file" @click="uploadPdf">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Subir PDF
              </button>
            </div>

            <!-- Mensajes -->
            <div v-if="message" class="alert mt-3" :class="success ? 'alert-success' : 'alert-danger'">
              {{ message }}
            </div>
            <hr>

            <vue-good-table v-if="tablaViajes" :columns="columns" :rows="paquetes" :search-options="{ enabled: true }"
              :pagination-options="{
                enabled: true,
                perPage: 5,
                perPageDropdown: [5, 10, 20],
                nextLabel: 'Siguiente',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Filas por página',
                ofLabel: 'de',
                allLabel: 'Todo'
              }">
              <template #table-row="props">
                <span v-if="props.column.field === 'acciones'">
                  <div class="d-grid gap-2">
                    <button class="btn btn-primary text-light" @click="borrarPaquete(props.row.id)" type="button">Borrar <i
                        class="fa-solid fa-trash"></i></button>
                    <button class="btn btn-info text-light" @click="descargarPdf(props.row.pdf)" type="button">Descargar
                      pdf <i class="fa-solid fa-file-pdf"></i></button>
                    <button type="button" class="btn btn-secondary text-light" data-bs-toggle="modal"
                      @click="traerPaquete(props.row.id)" data-bs-target="#exampleModal">
                      Editar <i class="fa-solid fa-pen"></i>
                    </button>
                  </div>
                </span>

                <span v-else-if="props.column.field === 'img'">
                  <img :src="getImgUrl(props.row.img)" alt="Imagen"
                    style="width: 60px; height: auto; border-radius: 4px;">
                </span>

                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
            <center>
              <loadingTicket v-if="ticketLoading" />
            </center>

          </div>

        </div>

      </div>
    </div>

  </div>
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Editar cambios</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <center>
                <loadingTicket v-if="ticketLoadingModal" />
              </center>

              <div v-if="formularioPaquete" class="card shadow-lg border-0 rounded-3">
                <div class="card-body p-4">

                  <h4 class="mb-3 text-center">✏️ Editar Paquete</h4>
                  <form @submit.prevent="updatePaquete" enctype="multipart/form-data">
                    <!-- Nombre -->
                    <div class="mb-3">
                      <label class="form-label">Nombre</label>
                      <input type="text" v-model="form.nombre" class="form-control">
                    </div>

                    <!-- Países -->
                    <div class="mb-3">
                      <label class="form-label">Países</label>
                      <input type="text" v-model="form.paises" class="form-control">
                    </div>

                    <!-- Tarifa -->
                    <div class="mb-3">
                      <label class="form-label">Tarifa</label>
                      <input type="number" v-model="form.tarifa" class="form-control">
                    </div>

                    <!-- Duración -->
                    <div class="mb-3">
                      <label class="form-label">Duración</label>
                      <input type="text" v-model="form.duracion" class="form-control">
                    </div>

                    <!-- Vuelo -->
                    <div class="mb-3">
                      <label class="form-label">Vuelo</label>
                      <input type="text" v-model="form.vuelo" class="form-control">
                    </div>

                    <!-- Salidas -->
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="form-label">Salidas Año</label>
                        <input type="text" v-model="form.salidasAños" class="form-control">
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">Salida Mes</label>
                        <input type="text" v-model="form.salidaMes" class="form-control">
                      </div>
                    </div>

                    <!-- Ciudades -->
                    <div class="mb-3">
                      <label class="form-label">Ciudades</label>
                      <textarea v-model="form.ciudades" class="form-control"></textarea>
                    </div>

                    <!-- Itinerario -->
                    <div class="mb-3">
                      <label class="form-label">Itinerario</label>
                      <textarea v-model="form.itinerario" class="form-control"></textarea>
                    </div>

                    <!-- Tarifas -->
                    <div class="mb-3">
                      <label class="form-label">Tarifas</label>
                      <textarea v-model="form.tarifas" class="form-control"></textarea>
                    </div>

                    <!-- Hoteles -->
                    <div class="mb-3">
                      <label class="form-label">Hoteles</label>
                      <textarea v-model="form.hoteles" class="form-control"></textarea>
                    </div>

                    <!-- Notas -->
                    <div class="mb-3">
                      <label class="form-label">Notas</label>
                      <textarea v-model="form.notas" class="form-control"></textarea>
                    </div>

                    <!-- Imagen -->
                    <div class="mb-3">
                      <label class="form-label">Imagen</label>
                      <input type="file" @change="onFileChange" class="form-control">
                    </div>

                    <!-- PDF -->
                    <!--   <div class="mb-3">
                      <label class="form-label">PDF (ruta)</label>
                      <input type="text" v-model="form.pdf" class="form-control">
                    </div> -->

                    <!-- Botón -->
                    <div class="d-grid">
                      <button class="btn btn-success" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                        Guardar cambios
                      </button>
                    </div>
                  </form>

                  <!-- Mensaje -->
                  <!--  <div v-if="message" class="alert mt-3"
                 :class="success ? 'alert-success' : 'alert-danger'">
              {{ message }}
            </div> -->

                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import { VueGoodTable } from "vue-good-table-next"
import "vue-good-table-next/dist/vue-good-table-next.css"
import loadingTicket from './loadingTicket.vue';
const token = localStorage.getItem("token")
import Swal from "sweetalert2";
export default {
  name: "PaquetesDash",
  components: {
    VueGoodTable,
    loadingTicket
  },
  data() {
    return {
      file: null,
      loading: false,
      message: "",
      success: false,
      ticketLoading: false,
      tablaViajes: false,
      formularioPaquete: false,
      ticketLoadingModal: false,
      paqueteId: null,
      paquetes: [],
      columns: [
        { label: "ID", field: "id" },
        { label: "Nombre", field: "nombre" },
        { label: "Países", field: "paises" },
        { label: "Tarifa", field: "tarifa" },
        { label: "Duración", field: "duracion" },
        { label: "Vuelo", field: "vuelo" },
        { label: "Salidas Años", field: "salidasAños" },
        { label: "Salida Mes", field: "salidaMes" },
        { label: "Ciudades", field: "ciudades" },
        { label: "Imagen", field: "img" },
        { label: "Acciones", field: "acciones" }
      ],
      form: {
        nombre: '',
        paises: '',
        tarifa: '',
        duracion: '',
        vuelo: '',
        salidasAños: '',
        salidaMes: '',
        ciudades: '',
        itinerario: '',
        tarifas: '',
        hoteles: '',
        notas: '',
        pdf: '',
        img: null // aquí guardamos el archivo
      },
    }
  },

  methods: {
    getImgUrl(path) {
      if (!path) return ''; // por si no hay imagen
      return `https://beauvoyage.net/${path}`; // ruta completa al storage
    },
    onFileChange(e) {
      this.form.img = e.target.files[0];
    },
    onFileChange2(e) {
      this.file = e.target.files[0]
    },
    async updatePaquete() {
      this.loading = true;
      try {
        let formData = new FormData();

        // Agregar solo campos que tengan valor
        for (let key in this.form) {
          if (this.form[key] !== null) {
            formData.append(key, this.form[key]);
          }
        }

        // Laravel espera PUT, pero usamos POST + _method


        let response = await axios.post(
          `https://beauvoyage.net/api/paqueteUp/${this.paqueteId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              "Authorization": `Bearer ${token}`
            }
          }
        );

        console.log(response.data);
        Swal.fire({
          icon: 'success',
          title: 'Paquete actualizado',
          text: 'El paquete ha sido actualizado exitosamente.',
          confirmButtonText: 'Aceptar'
        });
        this.getPaquetes(); // Actualiza la tabla después de editar
      } catch (error) {
        console.error(error.response?.data || error);
        alert('Error al actualizar ❌');
      } finally {
        this.loading = false;
      }
    },
    async uploadPdf() {
      if (!this.file) return

      this.loading = true
      this.message = ""

      const formData = new FormData()
      formData.append("pdf", this.file)

      try {
        const response = await axios.post("https://beauvoyage.net/api/pdfLeer", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`
          }
        })

        this.message = response.data.message || "PDF subido con éxito 🚀"
        this.success = true
        this.getPaquetes() // Actualiza la tabla después de subir
      } catch (error) {
        this.message = error.response?.data?.message || "Error al subir el PDF ❌"
        this.success = false
      } finally {
        this.loading = false
      }
    },
    async getPaquetes() {
      this.ticketLoading = true
      try {
        const response = await axios.get("https://beauvoyage.net/api/paquetes", {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
        this.ticketLoading = false
        this.paquetes = response.data
        this.tablaViajes = true
      } catch (error) {
        console.error("Error al traer los paquetes:", error)
      }
    },
    async traerPaquete(id) {
      this.formularioPaquete = false
      this.ticketLoadingModal = true
      try {
        const response = await axios.get("https://beauvoyage.net/api/paquete", {
          headers: {
            "Authorization": `Bearer ${token}`
          },
          params: { id }
        })
        this.form = response.data
        this.ticketLoadingModal = false
        this.formularioPaquete = true
        this.paqueteId = id;
      } catch (error) {
        console.error("Error al traer el paquete:", error)
      }
    },
    async descargarPdf(path) {
      const filename = path.replace("pdfs/", "");
      try {
        const response = await fetch(`https://beauvoyage.net/api/pdf/${filename}`, {
          method: 'GET',
        });

        if (!response.ok) throw new Error("Error al descargar el PDF");

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // Crear un link temporal para forzar la descarga
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // nombre del archivo
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error descargando PDF:", error);
      }
    },
    borrarPaquete(id) {
      console.log("ID de la fila:", id)
      const token = localStorage.getItem("token")
      try {
        axios.delete("https://beauvoyage.net/api/deletePaquete", {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: { id: id }

        }).then(response => {
          console.log("Respuesta del servidor:", response.data);
          Swal.fire({
            icon: 'success',
            title: 'Paquete eliminado',
            text: 'El paquete ha sido eliminado exitosamente.',
            confirmButtonText: 'Aceptar'
          });
          this.getPaquetes(); // Actualiza la lista después de borrar
        })
      } catch (error) {
        console.error("Error al borrar la reservación:", error);
      }
    }
  },
  created() {
    this.getPaquetes()
  }
};
</script>
<style>
.vgt-table td {
  max-width: 200px;
  /* ancho máximo de cada celda */
  white-space: nowrap;
  /* no saltar de línea */
  overflow: hidden;
  /* oculta el texto extra */
  text-overflow: ellipsis;
  /* agrega ... */
}
</style>